import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';
import { ComponentClass } from 'react';

export {
    refreshSchedulingGrid,
    resetSchedulingGrid,
    navigateToDate,
    updateFolderIds,
    updateSelectionItem,
} from './actions/publicActions';
export {
    default as convertToCalendarEvent,
    isSchedulingSelectionItem,
    isAttendeeItem,
} from './components/convertToCalendarEvent';
export {
    default as SchedulingGridViewState,
    SchedulingGridViewStateHost,
} from './schema/SchedulingGridViewState';
export { ComponentClass };
export { default as SchedulingGrid, createSchedulingConfig } from './components/SchedulingGrid';
export { SchedulingGridScrollBehavior } from './components/SchedulingGridScrollBehavior';

const lazyModule = new LazyModule(() =>
    import(/*webpackChunkName: "SchedulingGrid" */ './lazyIndex')
);
export const initializeSchedulingGrid = new LazyAction(lazyModule, m => m.initializeSchedulingGrid);

export const ComposeSchedulingGrid = createLazyComponent(lazyModule, m => m.ComposeSchedulingGrid);
